<template>
  <div>
    <div class="component-filters mb4 text-center">
      <el-radio-group v-model="filter" size="medium">
        <el-radio-button label="all">すべて</el-radio-button>
        <el-radio-button label="image">画像</el-radio-button>
        <el-radio-button label="text">テキスト</el-radio-button>
        <el-radio-button label="link">リンク</el-radio-button>
        <el-radio-button label="table">テーブル</el-radio-button>
        <el-radio-button label="mail">メール</el-radio-button>
        <el-radio-button label="movie">動画</el-radio-button>
        <el-radio-button label="map">地図</el-radio-button>
        <el-radio-button label="etc">その他</el-radio-button>
      </el-radio-group>
    </div>
    <div style="height:calc(90vh - 186px);overflow:scroll">
      <div class="grid grid-1-2 grid-mx2 grid-my2">
        <template v-for="(component, i) in filteredComponents">
          <div>
            <div class="component-wrapper flex column items-center" @click="selectComponent(component.id)">
              <div class="component-content">
                <h3 class="component-h3">{{ component.meta.title }}</h3>
                <p class="component-p">{{ component.meta.description }}</p>
              </div>
              <img class="component-img" :src="screenshot('components', component.id)">
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- <el-carousel :autoplay="false" type="card" height="400px">
      <template v-for="(component, i) in appComponents">
        <el-carousel-item :key="component.id">
          <div class="template-wrapper flex column justify-center items-center" @click="selectComponent(i)">
            <div class="template-content">
              <h3 class="template-h3">{{ component.meta.title }}</h3>
              <p class="template-p">{{ component.meta.description }}</p>
            </div>
            <img class="template-img" :src="screenshot('components', component.id)">
          </div>
        </el-carousel-item>
      </template>
    </el-carousel> -->
  </div>
</template>

<script>
import AppAPI from '@/api'
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'select-component',
  data: function () {
    return {
      allComponents: AppAPI.componentsArrayOfType('contents'),
      filter: 'all'
    }
  },
  computed: {
    /**
     * フィルターされたコンポーネントリスト
     */
    filteredComponents: function () {
      return this.filter === 'all' ? this.allComponents : this.allComponents.filter(component => component.meta.tags.includes(this.filter))
    }
  },
  methods: {
    /**
     * スクリーンショットアセットの取得
     */
    screenshot: function (type, id) {
      try {
        return require(`@/assets/${type}/${id}.png`)
      } catch (e) {
        return 'http://via.placeholder.com/960x400'
      }
    },

    /**
     * コンポーネントが選択されたら、選択されたコンポーネントを
     * 親コンポーネントへselectイベントと共に渡す
     */
    selectComponent: function (id) {
      const component = cloneDeep(this.allComponents.find(component => component.id === id))
      this.$emit('select', component)
    }
  },
  created: function () {
    if (process.env.NODE_ENV !== 'production') console.log('On SelectComponent created...')
  }
}
</script>

<style lang="scss">
.select-components-dialog {
  &.el-dialog__wrapper {
    height: 100%;
    height: 100vh;
  }
  .el-dialog {
    margin: 5vh auto !important;
    height: 90vh;
    overflow: scroll;
  }
}
</style>

<style lang="scss" scoped>
.component {
  &-wrapper {
    width: 100%;
    height: 100%;
  }
  &-content {
    padding: 1em;
  }
  &-h3 {
    text-align: center;
  }
  &-p {
    text-align: justify;
    margin-bottom: 0;
  }
  &-img {
    width: 100%;
  }
}
</style>


<doc>
# コンポーネント一覧を表示し、クリックされたコンポーネントのIDを返すコンポーネント

```
<select-component @select="onSelectComponent"></select-component>
```
</doc>


// WEBPACK FOOTER //
// src/components/app/SelectComponent.vue